import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../../providers/auth_provider';
import ViewBillInvoiceModal from './bill_invoice_modal';

export default function UserSubscriptions() {
    const [userSubscriptions, setUserSubscriptions] = useState([]);
    const { token } = useAuth();
    const [showModal, setShowModal] = useState(null);
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10);
    const [searchName, setSearchName] = useState('');
    const [searchPhone, setSearchPhone] = useState('');


    useEffect(() => {
        fetchUserSubscriptions(currentPage)
    }, [currentPage, limit, searchName, searchPhone]);

    const fetchUserSubscriptions = async (page) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/get/user/subscriptions?page=${page}&limit=${limit}&name=${searchName}&phone_no=${searchPhone}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            setUserSubscriptions(response.data.subscriptions);
            setPagination(response.data.pagination)
        } catch (error) {
            setUserSubscriptions(error?.response?.data?.subscriptions);
            console.log("Error fetching subscriptions", error);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    return (
        <>
            <Helmet>
                <title>Manage User Subscriptions - Enervybe</title>
            </Helmet>
            {/* Users List Table */}
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">User Subscriptions List</h5>
                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="d-flex justify-content-between px-5">
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search Name"
                                    aria-controls="DataTables_Table_0"
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                />
                            </div>
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <select
                                    name="DataTables_Table_0_length"
                                    aria-controls="DataTables_Table_0"
                                    className="form-select form-select-sm"
                                    value={limit}
                                    onChange={(e) => setLimit(e.target.value)}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="datatables-ajax table table-bordered dataTable no-footer" id="DataTables_Table_0" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Phone</th>
                                        <th>Subscription Name</th>
                                        <th>Purchased Frequencies</th>
                                        <th>Purchase Date</th>
                                        <th>Expiry Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userSubscriptions?.map((subscription, index) => (
                                        <tr className="odd" key={index}>
                                            <td>{index + 1}</td>
                                            <td>{subscription?.user?.first_name} {subscription?.user?.last_name}</td>
                                            <td>{subscription?.user?.country_code} {subscription?.user?.phone_no}</td>
                                            <td>{subscription?.plans?.name}</td>
                                            <td>
                                                {subscription?.user_frequency[0]?.frequencies
                                                    ?.map(freq => freq?.category?.name)
                                                    .join(', ')
                                                    .split('')
                                                    .reduce((acc, char, index) => {
                                                        // Add a <br /> tag after every 300 characters
                                                        if (index > 0 && index % 100 === 0) {
                                                            acc.push(<br key={index} />);
                                                        }
                                                        acc.push(char);
                                                        return acc;
                                                    }, [])
                                                    || "No frequency"
                                                }
                                            </td>

                                            <td>
                                                {new Date(subscription?.start_date).toLocaleDateString('en-CA')}
                                            </td>
                                            <td>
                                                {new Date(subscription?.end_date).toLocaleDateString('en-CA')}
                                            </td>
                                            <td onClick={() => setShowModal(subscription)} className='text-primary cursor-pointer fw-bold'>
                                                View
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage - 1)}>
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {pagination.pages && pagination.pages.map(page => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(page)}>
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage + 1)}>
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

            <ViewBillInvoiceModal showIfDetails={showModal} setShowModal={setShowModal} />
        </>
    );
}
